module.exports = __webpack_public_path__ + "static/media/close-circle.bd607c3c.png";